import 'antd/dist/reset.css';
import React, { useEffect, useRef, useState } from 'react';
import { Space, Table, message, Button, Input, Form, Modal, ConfigProvider, FloatButton, Popconfirm} from 'antd';
import { SearchOutlined, SaveOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import Highlighter                            from 'react-highlight-words';
import locale from "antd/es/locale/es_ES";
import _                                      from 'lodash';
import { ServicesData }       from "../services/ServicesData";

const stateInitial = {
  openEditModalState: false,
  openCreateModalState: false,
  selectedRow: {},
}

export const Comuneros = () => {

  ////////
  // Hooks
  ////////
  const [state, setState] = useState(stateInitial);
  const [comuneros, setComuneros] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleSearch = (
    selectedKeys, confirm, dataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  
  const getColumnSearchProps = (dataIndex, dataText) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataText}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys)[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      return record[dataIndex] 
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes((value).toLowerCase())
        : false;
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const case_columns = [
    {
      title: {},
      dataIndex: 'contadores',
      key: 'contadores',
      width: 150,
      render: (value, all) => 
        <Space align='horizontal'>
          <Button size='small' primary onClick={() => handleOpenEdit(all)} icon={<SaveOutlined />} />
          <Popconfirm title="¿Quiere eliminar el comunero?"
            onConfirm={() => {
              ServicesData.getComunero(all.id)
              .then((comunero) => {
                if (comunero.contadores.length >0){
                  messageApi.open({
                    type: 'error',
                    content: 'No se puede eliminar un comunero que tenga contadores. Contacte con administrador',
                  }); 
                }else{
                  ServicesData.deleteComunero(comunero.id).then(() => getComuneros())
                }
  
              });          
            }}
            onCancel={() => {}}
            okText="Si"
            cancelText="No"
          >
            <Button size='small' danger icon={<DeleteOutlined />} />
          </Popconfirm>
          
        </Space>
    },
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 150,
      sorter: (a, b) => a > b ? 1 : -1
    },   
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      ...getColumnSearchProps('nombre','nombre'),
    }
  ];

  useEffect(() => {
    document.title = "Regantes - Comuneros";
    getComuneros();
  }, []);

  /**
   * 
   * @param {object} values values.fecha of type moment, values.estado of type boolean
   */
  const getComuneros = async() => {
    setComuneros([]);
    ServicesData.getComuneros()
    .then((comuneros) => setComuneros(comuneros));      
  }

  const handleOpenEdit = (all) => {
    ServicesData.getComunero(all.id)
    .then((comunero) => {
      form.setFieldsValue(comunero)
      setState(prevState => ({
        ...prevState,
        openEditModalState: true,
        selectedRow: comunero
      }));  
    });
  }

  const handleOpenCreate = () => {
    form.setFieldsValue({nombre:""});
    setState(prevState => ({
      ...prevState,
      openCreateModalState: true,
      selectedRow :{}
    }));
  }

  const handleCreate = () => {
    let formulario = form.getFieldsValue();
    ServicesData.createComunero(formulario)
    .then(response =>{
      getComuneros();
      handleCloseModalState();
    })  
  }

  const handleCloseModalState = () => {
    setState(prevState => ({
      ...prevState,
      openEditModalState: false,
      openCreateModalState: false,
      selectedRow: {}
    }));
  }

  const handleSave = (datos) => {
      let formulario = form.getFieldsValue();
      ServicesData.updateComunero(datos.id,formulario)
      .then(response =>{
        _.forEach(formulario.contadores, (c,i) => {
            if(c.comunero_id){
              if (datos.contadores[i].id!=c.id && 
                datos.contadores[i].lectura >0){
                    messageApi.open({
                      type: 'error',
                      content: 'No se puede modificar el nombre de un contador con valor de lectura. Contacte con administrador',
                    }); 
              }else{
                ServicesData.updateContador(datos.contadores[i].id,c)
                .then(r => {});
              }
            }else{
              ServicesData.createContador(datos.id,c)
              .then(r => {});
            }
        });
        getComuneros();
        handleCloseModalState();
      })
  }

  return (
  <ConfigProvider locale={locale}>
    {contextHolder}
    <FloatButton onClick={() => handleOpenCreate()}
      shape="circle" type='primary' icon={<SaveOutlined/>}
    />
    <div style={{ backgroundColor: "#FFF", overflow: "auto" }}>
      <Table dataSource={comuneros} columns={case_columns} bordered pagination={{ pageSize: 50 }}/>
    </div>

    {/* Modals */}
    <Modal
      title={"Comunero "+state.selectedRow.id}
      open={state.openEditModalState}
      onCancel={handleCloseModalState}
      footer={[
        <Button onClick={handleCloseModalState}>
          Cancelar
        </Button>,
        <Button type="primary" onClick={() => handleSave(state.selectedRow)}>
          Guardar
        </Button>
      ]}
    >
      
      <Form
        layout='horizontal'
        labelCol={{span:4}}
        wrapperCol={{span:20}}
        form={form}
        autoComplete="off"
        size='small'
      >
      <Form.Item label="Nombre" name="nombre" rules={[{ required: true}]} size='small'>
        <Input />
      </Form.Item>
      <Form.List label="Contadores" name="contadores">
        {(fields, { add}) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
            
            <div key={key}>
              <Form.Item
                {...restField}
                label="Nombre"
                name={[name, 'id']}
                rules={[{required: true}]}
                style={{marginBottom: 4}}    
              >
                <Input placeholder="Contador" />
              </Form.Item>
              <Form.Item
                {...restField}
                wrapperCol={{span:24}} 
                name={[name, 'observaciones']}
                style={{marginBottom: 20}}
              >
                <Input placeholder="Observaciones"/>
              </Form.Item>
              </div>
            ))}
            <Form.Item wrapperCol={{span:24}} >
              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                Añadir contador
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
    </Modal>

    <Modal
      title={"Crear Comunero"}
      open={state.openCreateModalState}
      onCancel={handleCloseModalState}
      footer={[
        <Button onClick={handleCloseModalState}>
          Cancelar
        </Button>,
        <Button type="primary" onClick={() => handleCreate()}>
          Guardar
        </Button>
      ]}
    >
      <Form
        layout='horizontal'
        labelCol={{span:4}}
        wrapperCol={{span:20}}
        form={form}
        autoComplete="off"
        size='small'
      >
      <Form.Item label="Nombre" name="nombre" rules={[{ required: true}]} size='small'>
        <Input />
      </Form.Item>
    </Form>
    </Modal>
  </ConfigProvider>
)
}